export default __webpack_public_path__ + "static/image-three-mobile-4b637f6d70da936758ae68be6faae2e8.jpg";